import { useContext, useEffect, useState } from 'react';
import { CustomFieldsWidgetState } from '../state';
import { useWixPatternsContainer, formPageContext } from '@wix/bex-core/react';
import { parseFqdn } from '@wix/bex-core';

export interface UseCustomFieldsWidgetParams {
  fqdn: string;
  fieldName?: string;
}

export function useCustomFieldsWidget({
  fqdn: fqdnString,
  fieldName = 'extendedFields',
}: UseCustomFieldsWidgetParams) {
  const fqdn = parseFqdn(fqdnString);
  const container = useWixPatternsContainer();
  const formPageState = useContext(formPageContext);

  const [{ state, appLoaded }] = useState(() => {
    const widgetState = new CustomFieldsWidgetState({
      fqdn,
      container,
    });

    formPageState?.registerWidget(fieldName, widgetState);

    return {
      state: widgetState,
      appLoaded: widgetState._appLoadingStart(),
    };
  });

  useEffect(() => state.init({ appLoaded }), []);

  return state;
}
